import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';

const SantralGorusmeContext = createContext(null);

const EMPTY_SESSION = {
  isSantralFlow: false,
  gorusmeKaydiId: null,
  musteriId: null,
  santralTelefon: null,
  activeTab: null,
  maxAllowedTab: null,
  selectedCustomer: null,
};

export function SantralGorusmeProvider({ children }) {
  const [session, setSessionState] = useState(EMPTY_SESSION);

  const setSession = useCallback((partial) => {
    if (!partial) return;
    setSessionState((prev) => ({
      ...prev,
      ...partial,
      isSantralFlow: partial.isSantralFlow ?? prev.isSantralFlow ?? false,
    }));
  }, []);

  const updateSession = useCallback((partial) => {
    if (!partial) return;
    setSessionState((prev) => {
      if (!prev.isSantralFlow && !partial.isSantralFlow) return prev;
      return { ...prev, ...partial };
    });
  }, []);

  const clearSession = useCallback(() => {
    setSessionState(EMPTY_SESSION);
  }, []);

  const value = useMemo(
    () => ({ session, setSession, updateSession, clearSession }),
    [session, setSession, updateSession, clearSession],
  );

  return (
    <SantralGorusmeContext.Provider value={value}>
      {children}
    </SantralGorusmeContext.Provider>
  );
}

export function useSantralGorusme() {
  const ctx = useContext(SantralGorusmeContext);
  if (!ctx) {
    throw new Error('useSantralGorusme must be used within SantralGorusmeProvider');
  }
  return ctx;
}

export function useSantralGorusmeOptional() {
  return useContext(SantralGorusmeContext);
}

export default SantralGorusmeContext;
